<!--
 * @Description: 视频弹出组件
 * @Autor: zczhang
 * @Date: 2020-07-08 08:58:14
 * @LastEditors: zczhang
 * @LastEditTime: 2020-11-25 15:57:50
-->
<template>
  <div
    class="wrapper"
    style="fint-size:0"
  >
    <div style="min-height:100px">
      <div
        id="id_show_video"
        style="min-height:200px;width:100%;border-radius:5px"
        v-if="url"
      >
        <video
          :src="url"
          controls="controls"
          width="100%"
          height="100%"
          autoplay="autoplay"
        >
          您的浏览器不支持 video 标签。
        </video>

        <div
          style="width:100%;"
          v-if="url"
        >
          <div class="dataInfo">
            <p style="width:50%;font-size:16px">
              车牌号：{{data.yjCl}}
            </p>
            <p style="width:50%;font-size:16px">
              预警时间：{{data.yjTime}}
            </p>
          </div>
          <div
            class="dataInfo"
            style="border:none;display:flex;justify-content:center"
          >
            <el-button
              type="warning"
              size="small"
              @click="postWarningType(2)"
            >厕污乱倒</el-button>
            <el-button
              type="success"
              size="small"
              @click="postWarningType(3)"
            >设备误报</el-button>
          </div>
        </div>

      </div>
      <div
        v-else
        style="height:200px;line-height:200px;text-align:center"
      >
        该条预警无相关视频内容
      </div>
    </div>
  </div>
</template>

<script>
export default {
    components: {},
    props: {
        data: {
            type: Object,
            default: () => {},
        },
        show: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            url: '',
        }
    },
    computed: {},
    watch: {
        show(n, o) {
            n && this.getVideo(this.data)
        },
    },
    methods: {
        //获取视频文件
        getVideo(obj) {
            let self = this
          let { yjSb, yjTime } = obj
          if (yjTime.indexOf('2021-05-07') != -1) {
            self.url = 'http://124.70.206.40:50081/PU_3D12_00_20210507_142129.mp4'
          } else {
            // let { yjSb, yjTime } = obj
            //转化秒
            let time = Date.parse(yjTime) / 1000
            time -= 305
            //结束时间延后5分钟
            let endTime = Date.parse(yjTime) / 1000
            this.jswSession.swSearch({
              stSearchInfo: {
                iCount: 20,
              },
              stFilter: {
                szPUID: yjSb,
                iTimeCondition: 1,
                iTimeBegin: time,
                iTimeEnd: endTime,
                iFileType: 1,
                szDesc1: '',
                szDesc2: '',
              },
              callback: function (options, response, data) {
                if (response.getCode() == jSW.RcCode.RC_CODE_S_OK) {
                  let { content } = data
                  let { szFile } = content ? content[0] : ''
                  self.url = szFile
                  debugger
                  if (!this.session) {
                    return
                  }
                }
              },
            })
          }
        },
        postWarningType(type) {
            this.FUNCTIONS.systemFunction.interactiveData(
                this,
                this.GLOBAL.config.businessFlag.zxUser,
                'clYj',
                {
                    baseService: 'TGcYjServiceImpl',
                    yjType: type,
                    uuid: this.data.uuid,
                },
                null,
                (resultData) => {
                    this.$emit('update:show', false)
                },
                () => {}
            )
        },
    },
    created() {},
    mounted() {
        this.getVideo(this.data)
    },
    beforeDestroy() {},
}
</script>
<style lang="scss" scoped>
.dataInfo {
    width: 100%;
    height: 30px;
    border-bottom: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/LockVideoWindow.vue